import React from 'react';
import { FooterLinksRow } from 'molecules';
import { CONTACT_EMAIL } from 'data/contact';

/**
 * The one footer the whole site uses. It sits outside the routed outlet in
 * `App.tsx`, so every page carries the same contact details and the same legal
 * links — dressed in whatever brand the current route is wearing, because
 * every colour below comes from the `[data-brand]` contract.
 */
const SiteFooter: React.FC = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer-contact">
        <span className="site-footer-label">Get in touch</span>
        <a
          className="site-footer-email"
          href={`mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
            'Website enquiry'
          )}`}
        >
          {CONTACT_EMAIL}
        </a>
      </div>

      <nav className="site-footer-links" aria-label="Legal">
        <FooterLinksRow />
      </nav>

      <span className="site-footer-copyright">
        © {new Date().getFullYear()} Midnight Swim
      </span>
    </footer>
  );
};

export default SiteFooter;
